module.exports = "/images/other-life-event-background.png?1c6dd785c90f96611dedb4b313297dad";